import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Trophy, TrendingUp, Star, Sparkles } from 'lucide-react';

export function LiveActivityFeed({ items = [], maxItems = 8 }) {
  const displayItems = items.slice(0, maxItems);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
        <span className="text-sm font-medium text-slate-600">Live Feed</span>
      </div>
      
      <AnimatePresence mode="popLayout">
        {displayItems.map((item, index) => (
          <motion.div
            key={item.id || index}
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            className={`relative p-3 rounded-xl border shadow-sm ${
              item.score >= 8 
                ? 'bg-gradient-to-r from-amber-50 to-yellow-50 border-amber-200' 
                : 'bg-white border-slate-200'
            }`}
          >
            {item.score >= 8 && (
              <div className="absolute -top-1 -right-1">
                <motion.div
                  initial={{ scale: 0, rotate: -180 }}
                  animate={{ scale: 1, rotate: 0 }}
                  transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
                >
                  <Star className="w-5 h-5 text-amber-500 fill-amber-400" />
                </motion.div>
              </div>
            )}
            
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm text-slate-800 truncate">
                  {item.name}
                </p>
                <p className="text-xs text-slate-500 truncate">
                  {item.rollNumber}
                </p>
              </div>
              
              <div className="flex items-center gap-1">
                <motion.span
                  initial={{ scale: 1.5 }}
                  animate={{ scale: 1 }}
                  className={`text-lg font-bold ${
                    item.score >= 8 ? 'text-amber-600' : 
                    item.score >= 6 ? 'text-green-600' : 
                    item.score >= 4 ? 'text-blue-600' : 'text-slate-600'
                  }`}
                >
                  {item.score?.toFixed(1)}
                </motion.span>
                <span className="text-xs text-slate-400">/10</span>
              </div>
            </div>
            
            {item.score >= 8 && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
                className="mt-2 flex items-center gap-1 text-xs text-amber-600"
              >
                <Sparkles className="w-3 h-3" />
                <span>Outstanding!</span>
              </motion.div>
            )}
          </motion.div>
        ))}
      </AnimatePresence>
      
      {items.length === 0 && (
        <div className="text-center py-8 text-slate-400">
          <TrendingUp className="w-8 h-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm">Evaluations will appear here</p>
        </div>
      )}
    </div>
  );
}
